import { render, staticRenderFns } from "./CmsShow.vue?vue&type=template&id=36c9c886&scoped=true"
import script from "./CmsShow.vue?vue&type=script&lang=ts"
export * from "./CmsShow.vue?vue&type=script&lang=ts"
import style0 from "./CmsShow.vue?vue&type=style&index=0&id=36c9c886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9c886",
  null
  
)

export default component.exports